import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Avatar,
  Box,
  InputLabel,
  Select,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../AuthProvider";
import { useLocation } from "react-router-dom";

import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import { useParams } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
function StudentsBusWiseReports() {
  const { oId,board } = useAuth();
   const location = useLocation();
     const navigate = useNavigate();
   const { busNumber } = useParams();
   const busNumberPlate = sessionStorage.getItem("busNumberPlate"); // Retrieve from storage
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [transactionData, setTransactionData] = useState([]);

  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const isExportMenuOpen = Boolean(exportAnchorEl);
        
        const handleExportClick = (event) => {
          setExportAnchorEl(event.currentTarget);
        };
        
        const handleExportClose = () => {
          setExportAnchorEl(null);
        };
  



  useEffect(() => {
    const fetchDialogTableData = async () => {
      if (!busNumber) return; // Prevent API call if no admission number is selected

      setLoading(true);
      try {
        const response = await fetch(
          `${baseUrl}/api/reports/bus/students/byBusNumber/${busNumber}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Fetched Data:", data);
        setTransactionData(data || []); // Ensure it's always an array
      } catch (error) {
        console.error("Error fetching Bus Numbers:", error);
        setTransactionData([]); // Ensure state remains consistent
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchDialogTableData();
  }, [busNumber, oId]); // Re-fetch when `selectedadmissionNo` or `oId` changes





  // Export to Excel
    const exportToExcel = () => {
  const filteredData = transactionData.map((row, index) => ({
    SNo: index + 1,
    StudentName: `${row.studentFirstName} ${row.studentLastName}`,
    Class: row.romanNumberClass,
    Section: row.sections,
    FatherName: row.fatherName,
    FatherPhone: row.fatherPhoneNumber,
    Distance: row.distance,
    PickupLocation: row.studentPickupLocation,
  }));

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`${busNumber}_Students_List`);

  worksheet.columns = [
    { header: "S.No", key: "SNo", width: 8 },
    { header: "Student Name", key: "StudentName", width: 25 },
    { header: "Class", key: "Class", width: 10 },
    { header: "Section", key: "Section", width: 10 },
    { header: "Father Name", key: "FatherName", width: 20 },
    { header: "Father Phone", key: "FatherPhone", width: 15 },
    { header: "Distance", key: "Distance", width: 12 },
    { header: "Pickup Location", key: "PickupLocation", width: 30 },
  ];

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "DDEEFF" },
    };
  });

  filteredData.forEach((data) => {
    worksheet.addRow(data);
  });

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${busNumber}_Students_List.xlsx`;
    link.click();
  });

  handleExportClose();
};

     
     // Export to PDF
     const exportToPDF = () => {
  const doc = new jsPDF("landscape"); // Landscape for wider tables

  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
 doc.text(`${busNumber}_Students Report`, 14, 10);

//   doc.setFontSize(10);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Generated On: ${new Date().toLocaleDateString()}`, 14, 16);

  doc.autoTable({
    startY: 22,
    head: [[
      "S.No",
      "Student Name",
      "Class",
      "Section",
      "Father Name",
      "Father Phone",
      "Distance",
      "Pickup Location",
    ]],
    body: transactionData.map((row, index) => [
      index + 1,
      `${row.studentFirstName} ${row.studentLastName}`,
      row.romanNumberClass,
      row.sections,
      row.fatherName,
      row.fatherPhoneNumber,
      row.distance,
      row.studentPickupLocation,
    ]),
    styles: {
      fontSize: 9,
      cellPadding: 3,
      halign: "center",
    },
    headStyles: {
      fillColor: [60, 57, 114], // Dark purple
      textColor: 255,
    },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    theme: "grid",
  });

 doc.save(`${busNumber}_Students_List.pdf`);
  handleExportClose();
};

     
     
    


  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
    <Card
      style={{
        // margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        // maxHeight: "100vh",
        // overflow: "hidden",
        width: "100%",
      }}
    >
      <CardContent>
         
      <Box 
  display="flex" 
  justifyContent="space-between" 
  alignItems="center" 
  sx={{ mb: 2 }}
>
  {/* Left side: Back + Title */}
  <Box display="flex" alignItems="center">
    <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
      {busNumberPlate} / Students List
    </Typography>
  </Box>

  {/* Right side: Export Button + Menu */}
  <Box display="flex" gap={2}>
    <Button 
      variant="contained" 
      onClick={handleExportClick}  
      style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
      startIcon={<PresentToAllIcon />}  
    >
      Export
    </Button>

    <Menu
      anchorEl={exportAnchorEl}
      open={isExportMenuOpen}
      onClose={handleExportClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        },
      }}
    >
      <MenuItem 
        onClick={exportToExcel}
        sx={{
          color: "#3f51b5",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#e8f0fe" },
        }}
      >
        <ListItemIcon sx={{ color: '#00796b' }}>
          <SimCardDownloadIcon />
        </ListItemIcon>
        <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
      </MenuItem>
      
      <MenuItem 
        onClick={exportToPDF}
        sx={{
          color: "#d32f2f",
          fontWeight: "bold",
          "&:hover": { backgroundColor: "#fdecea" },
        }}
      >
        <ListItemIcon sx={{ color: '#d32f2f' }}>
          <PictureAsPdfIcon />
        </ListItemIcon>
        <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
      </MenuItem>
    </Menu>
  </Box>
</Box>

   

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />

        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "800px",
            overflow: "auto",
            //  maxHeight: "800px",
            //   overflow: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Student Name
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                 Class
                </TableCell>
               
               
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Section
                </TableCell>

                
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Father Name 
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Distance
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Pickup Location
                </TableCell>
                

              </TableRow>
            </TableHead>

            <TableBody>
              {/* {!hasFetchedOnce || loading ? ( */}
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={12}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <CircularProgress />
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Loading Data...
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : transactionData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                transactionData.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "30px", // Reduced row height
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white"; // Default color
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                        {`${row.studentFirstName} ${row.studentLastName}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.romanNumberClass}
                    </TableCell>
                   


                    
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                         {row.sections}
                    </TableCell>

                    
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                     {row.fatherName || "NA"}
                    </TableCell>
                     <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                     {row.fatherPhoneNumber}
                    </TableCell>

  <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                     {row.distance} Km
                    </TableCell>
                      <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                     {row.studentPickupLocation}
                    </TableCell>
                   
                   
                    {/* <TableCell
                      sx={{
                        borderLeft: "1px solid #ddd",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      {/* <Button
                        type="button"
                        // onClick={() => handleViewClick(row)} // Open dialog with the row data
                        onClick={() =>
  navigate(`/BusFeeReceipt/${admissionNumber}`, {
    state: {
      rowData: row,
     
    },
  })
}
                        sx={{
                          backgroundColor: "#1976d2",
                          color: "white",
                          fontWeight:'bold',
                          fontSize: "0.6rem", // Reduces the font size
                          height: "25px", // Reduces the height
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        }}
                      >
                        Receipt
                      </Button> 
                    </TableCell> */}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

   
      </CardContent>
    </Card>
    </Box>
  );
}

export default StudentsBusWiseReports;